import type { RootState } from "store/reducers/main";

export const selectUseSeries = (state: RootState) => state.CreateEventReducer.workingEvent?.settings.useSeries;